import { parseAsNumberLiteral, useQueryState } from "nuqs"
import { useState } from "react"

export type PaginationSettings = {
    currentPage: number,
    setCurrentPage: (currentPage: number) => void,
    pageCount: number,
    perPage: number,
    total?: number,
    setTotal: (total: number) => void,
    limit: number,
    offset: number,
}

export const usePagination = (params: { perPage: number, total?: number }): PaginationSettings => {
    const [total, setTotal] = useState<number | undefined>(params.total)

    const pageCount = total ? Math.ceil(total / params.perPage) : 1

    const [currentPage, setCurrentPage] = useQueryState(
        'page',
        parseAsNumberLiteral(
            Array.from({ length: pageCount }, (_, i) => i + 1),
        ).withDefault(1),
    )

    return {
        currentPage: Number(currentPage),
        setCurrentPage,
        pageCount,
        perPage: params.perPage,
        total,
        setTotal,
        limit: params.perPage,
        offset: (currentPage - 1) * params.perPage,
    }
}